 // new WheelCarousel('functionIntroductionStickyBox','functionIntroductionSticky','functionIntroductionMove',0.2);

    var functionIntroductionSwiper = new Swiper("#functionIntroductionSwiper", {
        slidesPerView: 'auto',
        spaceBetween: 0,
        touchRatio:1.5,
        slidesOffsetBefore: 4,
        updateOnWindowResize: true,
        centeredSlides : true,
        navigation:{
            prevEl: '#functionIntroductionNavigationButtonPrev',
            nextEl: '#functionIntroductionNavigationButtonNext',
        },
        pagination: {
            el: ".functionIntroductionSwiperPagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"><span id="functionIntroductionSwiperPagination-' + index + '" class="functionIntroductionSwiperPagination"> </span></span>';
            }
        }
    });

    var functionIntroductionMobileSwiper = new Swiper("#functionIntroductionSwiperMobile", {
        slidesPerView: 'auto',
        spaceBetween: 16,
        touchRatio:1.5,
        slidesOffsetBefore: 0,
        updateOnWindowResize: true,
        centeredSlides : true,
        pagination: {
            el: ".functionIntroductionMobileSwiperPagination",
            clickable: true,
            renderBullet: function (index, className) {
                return '<span class="' + className + '"><span id="functionIntroductionMobileSwiperPagination-' + index + '" class="functionIntroductionMobileSwiperPagination"> </span></span>';
            },
        },
        navigation:{
            prevEl: '#functionIntroductionMobileNavigationButtonPrev',
            nextEl: '#functionIntroductionMobileNavigationButtonNext',
        },

        on: {
            // init: function () {
            //     // 设置新的 slidesOffsetAfter 值
            //     this.params.slidesOffsetAfter = parseInt($(".functionIntroductionSwiperMobile").css('padding-left'));
            //     this.update();
            // },
            // resize: function(){
            //     this.params.slidesOffsetAfter = parseInt($(".functionIntroductionSwiperMobile").css('padding-left'));
            //     this.update(); //窗口变化时，更新Swiper的一些属性，如宽高等
            // }
        },

    });

    setSwiperContentHeight('functionIntroductionContentMobile');

    $(window).on('resize', function () {
        setSwiperContentHeight('functionIntroductionContentMobile');
    })
